import { Dispatch } from '@reduxjs/toolkit';
import { Notifications as NotificationsSharedComponent } from '@stern-ui/ui';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { RootState } from '@/stores/store';

import { dismissNotification, NotificationProps } from './notificationsSlice';

export const Notifications = () => {
	const { notifications } = useSelector((state) => (state as RootState).notifications);
	const filteredNotificaitons = notifications.filter(
		(notification: NotificationProps, index: number, self: NotificationProps[]) =>
			index ===
			self.findIndex(
				(n) => JSON.stringify(n.message) === JSON.stringify(notification.message)
			)
	);

	const onDismiss = (id: string, dispatch: Dispatch) => {
		dispatch(dismissNotification(id));
	};

	const location = useLocation();
	// surpress notification errors on public facing survey pages as they are displayed differently
	if (location.pathname?.includes('/survey/')) return null;

	return (
		<NotificationsSharedComponent
			notificationsList={filteredNotificaitons}
			onDismiss={onDismiss}
		/>
	);
};
